module.exports = __webpack_public_path__ + "muli-italic-webfont.asset.65b05aa07fdc850755e026f9591e26cb.woff";